import { render, staticRenderFns } from "./AddMaterialModalForm.vue?vue&type=template&id=b72050a2"
import script from "./AddMaterialModalForm.vue?vue&type=script&lang=js"
export * from "./AddMaterialModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports